import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'app'

const getCurrenciesState = (state: RootState) => state.common.currencies

export const getCurrencies = createSelector(
  getCurrenciesState,
  state => state.currencies.data
)

export const getCurrenciesOptions = createSelector(getCurrencies, currencies =>
  currencies.map(currency => ({ title: currency.name, value: currency.id }))
)

export const getLoadingState = createSelector(
  getCurrenciesState,
  state => state.currencies.loading
)
